import { render, staticRenderFns } from "./WercbergerHotlineCalls.vue?vue&type=template&id=479299ec&"
import script from "./WercbergerHotlineCalls.vue?vue&type=script&lang=js&"
export * from "./WercbergerHotlineCalls.vue?vue&type=script&lang=js&"
import style0 from "./WercbergerHotlineCalls.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports